export default __webpack_public_path__ + "static/media/active-clock-icon-inspire.82bc6c1b79761170d44155cab5d70ed0.svg";